// engine จำลอง: ไม่ใช้ WebGPU ไม่โหลดโมเดล — ใช้ในโหมด mock และ unit test (ผลลัพธ์ถูกตีตรา mock:true = ไม่หักคอยน์)
export function createMockBackend(replyFn) {
  const reply = replyFn || ((req) => {
    const last = [...(req.messages || [])].reverse().find((m) => m.role === "user");
    if (req.json) {
      return JSON.stringify({ name: "ตัวละครตัวอย่าง", tagline: "[โหมดจำลอง] ตัวละครที่สร้างโดยระบบจำลอง", description: "[โหมดจำลอง] " + String(last ? last.content : "").slice(0, 200), greeting: '*ยิ้มทักทาย* "สวัสดี ยินดีที่ได้รู้จักนะ"', tagIds: [], flag: "green", keywords: [] });
    }
    return '[โหมดจำลอง] *ยิ้มรับฟัง* "ได้ยินแล้วนะ: ' + String(last ? last.content : "").slice(0, 80) + '" (AI ในเบราว์เซอร์ยังไม่ได้เปิดใช้ จึงเป็นข้อความจำลอง)';
  });
  return {
    mock: true,
    alwaysReady: true,
    supported: () => true,
    isCached: async () => true,
    load: async () => {},
    unload: async () => {},
    interrupt: () => {},
    async *stream(req) {
      const text = reply(req);
      for (let i = 0; i < text.length; i += 6) yield text.slice(i, i + 6);
    },
  };
}
